/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * UC Monitoring API
 * UC Monitoring: Call Quality + Room Utilization
 * OpenAPI spec version: 1.0
 */

/**
 * Video quality rating, computed by us
 * @nullable
 */
export type CallVideoRating = (typeof CallVideoRating)[keyof typeof CallVideoRating] | null;

export const CallVideoRating = {
  GOOD: 'good',
  FAIR: 'fair',
  POOR: 'poor',
  UNCLASSIFIED: 'unclassified',
} as const;
